
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightEmergencyColourOff as ObiLightEmergencyColourOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-emergency-colour-off.js';
 
 
 

 
 export const ObiLightEmergencyColourOff = createComponent({
   react: React,
   tagName: 'obi-light-emergency-colour-off',
   elementClass: ObiLightEmergencyColourOffElement,
   events: {
     
   }
  });
 
 